<template>
  <el-dialog
    :title="title"
    :visible="isVisible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :fullscreen="false"
    top="5vh"
    width="600px"
    center
  >

    <el-form :model="data">

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="" >
            <el-switch v-model="data.enable"
              size="small"
              active-text="Activada"
              inactive-text="Desactivada"
              inactive-color="#ff4949"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="!isNewRule && isAdmin">
          <el-popconfirm
            confirm-button-text='Si'
            cancel-button-text='No, Salir'
            icon="el-icon-info"
            iconColor="red"
            title="¿Estás seguro de eliminarlo?"
            @confirm="handleDeleteDistribution()">
            <el-button
              slot="reference"
              type="danger"
              size="small"
              icon="el-icon-delete-solid">
              Eliminar
            </el-button>

          </el-popconfirm>

        </el-col>
      </el-row>

      <el-row :gutter="20">

        <el-col :span="10">
          <el-form-item label="Nombre" >
            <el-input
              v-model="data.name"
              size="small"
              autocomplete="off"
              clearable
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="14" >
          <el-form-item label="Ambiente" >
            <el-radio-group v-model="data.environment" size="small">
              <el-radio-button label="production">Production</el-radio-button>
              <el-radio-button label="test">Staging</el-radio-button>
              <el-radio-button label="development">Development</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="Proveedor" >
            <el-select
              v-model="data.provider._id" placeholder="Sin proveedor" size="small" clearable>
              <el-option
                v-for="provider in providers"
                :key="provider._id"
                :label="provider.name"
                :value="provider._id">

                <span style="float: left">
                  <i class="el-icon-postcard"></i>
                  {{ provider.name }}
                </span>
                <span style="float: right;">
                  <div v-if="provider.is_operational">
                    <el-tag  class="blob green" size="mini" effect="dark" type="success" >
                      Activo
                    </el-tag>
                  </div>
                  <div v-else>
                    <el-tag size="mini" effect="dark" type="danger">
                      Desactivado
                    </el-tag>
                  </div>
                </span>

              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        type="success"
        icon="el-icon-check"
        @click="saverule"
        round>
        Guardar cambios
      </el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import http from '@/utils/http';

export default {
  name: 'EditOrCreateruleModal',
  props: ['id', 'isVisible', 'carrier', 'isNewRule', 'rule', 'ruleType'],
  data() {
    return {
      providers: [],
      title: '',
      data: {
        credential: {
          _id: '',
        },
        provider: {
          _id: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
  },
  watch: {
    async isVisible() {
      if (!this.isVisible) return;
      const name = this.isNewRule ? this.carrier : `${this.rule?.carrier}/${this.rule?.name}`;
      this.title = `Regla de ${name}`;
      this.data = this.rule ? ({ ...this.rule }) : this.data;
      // FIXME: Pending review, contemplate provider null
      this.data.provider = this.rule?.provider?._id ? this.data.provider : { _id: null };

      const { data } = await http.get(`/providers/?carrier=${this.carrier}`);
      this.providers = data;
    },
  },

  methods: {
    async saverule() {
      const payload = {
        provider: this.data?.provider?._id,
        carrier: this.carrier,
        enable: this.data.enable || false,
        environment: this.data.environment,
        name: this.data.name,
        type: this.ruleType,
        clients: [],
      };

      try {
        if (this.isNewRule) {
          await http.post('/rules', payload);
        } else {
          await http.put(`/rules/${this.data._id}`, payload);
        }
        this.$emit('update');
        this.showSuccessEvent();
      } catch (error) {
        console.log(error);
        this.$emit('close');
        this.showErrorEvent();
      }
    },
    showSuccessEvent() {
      const options = {
        message: 'Se guardaron los cambios con exito.',
        type: 'success',
        duration: 4000,
      };
      this.$message(options);
    },
    showErrorEvent() {
      const options = {
        duration: 0,
        showClose: true,
        message: 'Ocurrio un problema',
        type: 'error',
      };
      this.$message(options);
    },
    handleClose() {
      this.$emit('close');
    },
    update() {
      this.$emit('update');
    },

    async handleDeleteDistribution() {
      const options = {
        message: `La regla ${this.data.name} ha sido borrada... Espero que sepas lo que haces.`,
        type: 'warning',
        duration: 4000,
      };
      try {
        await http.delete(`/rules/${this.data._id}`);

        this.$emit('update');
        this.handleClose();
        // this.$delete(this.distributions, index);
      } catch (error) {
        options.message = error;
        options.type = 'error';
      } finally {
        this.$message(options);
      }
    },
  },
};
</script>
<style>
  .el-select-dropdown__item {
    padding: 10px 20px;
    height: 55px;
    width: 330px;
  }
  .el-form-item__label {
    font-size: 14px;
    font-weight: 100;
    line-height: 14px;
  }
  .el-switch__label * {
    line-height: 1;
    font-size: 14px;
    font-weight: 100;
  }
  .el-input .el-input--small .el-input--suffix {
    width: 260px;
  }
</style>
